import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { useEffect, useState } from 'react';

type TUseLoginSuccess = [boolean];

/** triggers only on successful login and returns boolean  */
const useLoginSuccess = (instance: PublicClientApplication): TUseLoginSuccess => {
  const [loginSuccess, setLoginSuccess] = useState(false);
  useEffect(() => {
    instance.addEventCallback((message) => {
      if (message.eventType === EventType.LOGIN_SUCCESS) {
        setLoginSuccess(!!message.eventType);
      }
    });
    return () => setLoginSuccess(false);
  }, [instance]);

  return [loginSuccess];
};
export default useLoginSuccess;
